const Point = ({icon, title, content}) => {
    return (
        <div data-aos="fade-up"
             className="flex flex-col text-left max-md:text-center gap-6 justify-normal items-start max-md:items-center">
            <div className="bg-secondary-light p-4 rounded-full aspect-square shrink
                            drop-shadow-2xl flex justify-center">
                <img src={icon} alt="Icon" className="w-12 max-w-20 min-w-12 text-primary"/>
            </div>
            <div>
                <div className="text-xl font-bold">{title}</div>
                <div className="text-sm mt-2">{content}</div>
            </div>
        </div>
    );
}

export default Point